// extracted by mini-css-extract-plugin
module.exports = {"resourceCard":"ResourceCard_resourceCard__3jSnt","resourceImage":"ResourceCard_resourceImage__3ZkaG","resourceItem":"ResourceCard_resourceItem__1BVtd"};